// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"2f2ac0cf","312":"a3bd337d","395":"884a8eda","453":"325af35f","599":"1035f095","673":"76f5c96c","778":"3db63d64","879":"ec8464fb","900":"8747d7b3"}[chunkId] + ".chunk.js";
};